import { FiWifiOff } from 'react-icons/fi'

interface OfflineIndicatorProps {
  isOnline: boolean
}

const OfflineIndicator = ({ isOnline }: OfflineIndicatorProps): JSX.Element | null => {
  // Only show when offline
  if (isOnline) {
    return null
  }

  return (
    // top-4 is measured from the top of the SCREEN on a home-screen web app
    // (translucent status bar), which on iPad is where the clock sits — hence the
    // safe-area floor. env() is 0 everywhere without an inset, so desktop is
    // unchanged.
    <div className="fixed top-[max(1rem,calc(env(safe-area-inset-top)+0.25rem))] left-4 bg-black bg-opacity-70 text-white rounded-lg px-3 py-2 text-sm z-[1000] flex items-center gap-2 shadow-lg">
      <FiWifiOff className="flex-shrink-0" />
      <span>Offline</span>
    </div>
  )
}

export default OfflineIndicator
